import { Button, Col, Row, Typography } from "antd";
import { PlusOutlined } from "@ant-design/icons";

import { AdminMenuLayout } from "../../../shared/components";
import { DrawerSauces, WrapperCardSauces } from "./styled";
import { TableSauces } from "./TableSauces";
import React from "react";
import { SaucesForm } from "./form";

const { Title } = Typography;

export const Sauces = () => {
  const [openModalCreateSauce, setOpenModalCreateSauce] =
    React.useState<boolean>(false);
  return (
    <AdminMenuLayout pageDescription="Sauces" title="Sauces">
      <WrapperCardSauces>
        <Row
          gutter={[8, 8]}
          style={{
            padding: "10px",
            width: "100%",
          }}
        >
          <Col
            span={24}
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Title
              level={3}
              style={{
                margin: 0,
                fontWeight: 600,
                color: "#262626",
              }}
            >
              Salsas
            </Title>
            <Button
              type="primary"
              size="large"
              onClick={() => setOpenModalCreateSauce(true)}
              icon={<PlusOutlined />}
              style={{
                borderRadius: 20,
                height: 44,
                paddingLeft: 24,
                paddingRight: 24,
                fontWeight: 600,
                fontSize: 15,
                boxShadow: "0 2px 8px rgba(233, 87, 53, 0.3)",
                display: "flex",
                alignItems: "center",
                gap: 8,
              }}
            >
              Agregar nueva salsa
            </Button>
          </Col>
        </Row>

        <TableSauces />
        <DrawerSauces
          title={`Agregar una salsa`}
          open={openModalCreateSauce}
          width={420}
          centered
          destroyOnClose
          footer={null}
          onCancel={() => setOpenModalCreateSauce(false)}
        >
          <SaucesForm setOpenModalCreate={setOpenModalCreateSauce} />
        </DrawerSauces>
      </WrapperCardSauces>
    </AdminMenuLayout>
  );
};
